package io.horion.cv.styles

import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.flexShrink
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.scale
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.selectors.hover
import io.horion.cv.utils.Colors
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba

val CoverLetterStyle = CssStyle {
    base {
        Modifier
            .boxShadow(
                offsetX = 0.px,
                offsetY = 2.px,
                blurRadius = 6.px,
                spreadRadius = 3.px,
                color = rgba(0, 1, 6, 0.1)
            )
            .transition {
                property("shadow")
                duration(300.ms)
                property("transform")
                duration(300.ms)
            }
    }
    hover {
        Modifier
            .scale(1.02)
            .boxShadow(
                offsetX = 0.px,
                offsetY = 4.px,
                blurRadius = 12.px,
                spreadRadius = 6.px,
                color = rgba(0, 1, 6, 0.15)
            )
    }
}

// Style du bouton : définit les variables CSS, change au hover
val ViewMoreButtonStylecss = CssStyle {
    base {
        Modifier.styleModifier {
            property("--arrow-width", "0px")
            property("--arrow-opacity", "0")
            property("--arrow-margin", "0px")
            property("--arrow-target-width", "20px") // largeur cible par défaut (mobile)
        }
    }
    hover {
        Modifier.styleModifier {
            property("--arrow-width", "var(--arrow-target-width)")
            property("--arrow-opacity", "1")
            property("--arrow-margin", "8px")
        }
    }
    Breakpoint.MD {
        Modifier.styleModifier {
            property("--arrow-target-width", "30px") // largeur cible différente en desktop
        }
    }
}

// Style de l'icône : lit les variables CSS posées par le parent
// Conteneur qui anime uniquement l'ouverture (clip), ne touche pas à la forme de l'icône
val ArrowWrapperStyle = CssStyle {
    base {
        Modifier.styleModifier {
            property("width", "var(--arrow-width, 0px)")
            property("opacity", "var(--arrow-opacity, 0)")
            property("margin-left", "var(--arrow-margin, 0px)")
            property("overflow", "hidden")
            property("flex-shrink", "0")
            property("display", "flex")
            property("align-items", "center")
            property("justify-content", "flex-start")
            property(
                "transition",
                "width 400ms cubic-bezier(0.2, 1.2, 0.2, 1.0), " +
                        "opacity 300ms ease, " +
                        "margin-left 400ms cubic-bezier(0.2, 1.2, 0.2, 1.0)"
            )
        }
    }
}

// Style de l'icône elle-même : taille FIXE (via font-size, pas width/height), jamais animée
val ArrowImageStyle = CssStyle {
    base {
        Modifier
            .fontSize(20.px)
            .flexShrink(0)
    }
    Breakpoint.MD {
        Modifier
            .fontSize(30.px)
    }
}

val CoverLetterSectionStyle = CssStyle {
    base {
        Modifier
            .fontSize(14.px)
            .border(0.px, LineStyle.Solid, Colors.bluelight)
            .backgroundColor(Colors.linear)
            .color(Colors.White)
            .padding(
                topBottom = 15.px ,
                leftRight = 10.px
            )
            .styleModifier {
                property(
                    "transition",
                    "background-color 400ms cubic-bezier(0.2, 1.2, 0.2, 1.0), " +
                            "color 400ms cubic-bezier(0.2, 1.2, 0.2, 1.0), " +
                            "width 400ms cubic-bezier(0.2, 1.2, 0.2, 1.0), " +
                            "padding 400ms cubic-bezier(0.2, 1.2, 0.2, 1.0)"
                )
            }
    }
    Breakpoint.MD {
        Modifier
            .fontSize(30.px)
            .padding(topBottom = 40.px ,
                leftRight = 35.px
            )
    }
    hover {
        Modifier
            .border(2.px, LineStyle.Solid, Colors.bluelight)
            .backgroundColor(Colors.White)
            .color(Colors.bluelight)
    }
    cssRule(":hover img") {
        Modifier.styleModifier {
            property("width", "40px")
            property("opacity", "1")
            property("margin-left", "12px")
        }
    }
}
